module.exports = __webpack_public_path__ + "img/太极-1.6d28e5ab.png";